export class AccessDeniedError extends Error {}
export class PermissionsUnavailableError extends Error {}
export class AuthenticationRequiredError extends Error {}

export function checkEditorResponse(response: Response): Response {
    if (response.status === 401) throw new AuthenticationRequiredError('Authentication required');
    if (response.status === 403) throw new AccessDeniedError('Access denied');
    if (response.status === 503) throw new PermissionsUnavailableError('Permissions unavailable');
    if (!response.ok) throw new Error(`Request failed (${response.status})`);
    return response;
}
